import Translator from 'bazinga-translator'
import { PaymentNotification } from 'components/UserNotifications/schemas/paymentNotificationSchema'
import { money } from 'utils/numbers'

import { UserNotificationHandler } from '../type'
import SimpleDialog from 'UI/SimpleDialog'

export class PaymentNotificationHandler implements UserNotificationHandler<PaymentNotification> {
  render(notification: PaymentNotification, confirm: () => void) {
    SimpleDialog.dialog({
      title: this.getTitle(notification),
      type: 'confirm',
      content: `<h4>${this.getBody(notification)}</h4>`,
      buttons: {
        accept: {
          label: Translator.trans('notifications.payment.accept'),
          callback: () => {
            confirm()
          },
        },
      },
    })
  }

  private getTitle(notification: PaymentNotification) {
    return notification.type === 'bonus'
      ? Translator.trans(`notifications.type.payment.header.bonus`)
      : Translator.trans(`notifications.type.payment.header.general`)
  }

  private getBody(notification: PaymentNotification) {
    if (notification.type === 'bonus') {
      return Translator.trans(`notifications.in_game.type.payment.body.bonus`, {
        amount: money(notification.amount, false),
      })
    }

    if (notification.type === 'happyHour') {
      return Translator.trans(`notifications.in_game.type.payment.body.happyHour`, {
        amount: money(notification.amount, false),
      })
    }

    return Translator.trans(`notifications.in_game.type.payment.body.general`, {
      amount: money(notification.amount, false),
    })
  }
}
